import React, { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import TourModal from "./TourModal";
import { useAuth } from "@/contexts/AuthContext";

const Layout = () => {
  const { user, onboarding, loading } = useAuth();
  const [showTour, setShowTour] = useState(false);

  useEffect(() => {
    if (onboarding?.completed && !onboarding?.tour_completed) setShowTour(true);
  }, [onboarding]);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-white"><div className="text-gray-500">Loading...</div></div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  // Onboarding is OPTIONAL — never force-redirect. The /onboarding route is still reachable manually.

  return (
    <div className="min-h-screen flex bg-white">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
      {showTour && <TourModal onClose={() => setShowTour(false)} />}
    </div>
  );
};

export default Layout;
